<a _ngcontent-hir-c279="" href="javscript:;" class="close-section ng-tns-c279-12 ng-star-inserted" (click)="closeMenu()"></a>
<ul class="sub-menu-content">
    <li *ngFor="let item of list" class="{{ item }}">
        <div class="build">
            <a href="javascript:;" (click)="openMap(item.name)" [routerLink]="[]">
                <!-- <div class="text">
                </div> -->
                <div class="text custom-text">
                    <img [src]="'../assets/img/' + item.icon" alt="icon" class="custom-icon">
                </div>
                <div class="title">
                    {{ item.name | translate }}
                </div>
            </a>
        </div>
    </li>
    <div *ngIf="enableCustomMarkers">
        <li *ngFor="let item of additionalCategories" class="{{ item }}" >
            <div class="build">
                <a href="javascript:;" (click)="openMap(item.internalName)" [routerLink]="[]">
                    <!-- <img [src]="item.icon" alt="icon" class="custom-icon"> -->
                    <div class="text custom-text">
                        <img [src]="'../assets/img/' + item.icon" alt="icon" class="custom-icon">
                    </div>
                    <div class="title">
                        {{ item.name | translate }}
                    </div>
                </a>
            </div>
        </li>
    </div>
</ul>